import { systemUnderMaintenance$ } from '@euler/functions/maintenanceMode';
import { ResponseContext } from '@euler/lib/request';
import { Middleware } from '@euler/lib/request/Middleware';

export class MaintenanceMiddleware implements Middleware {
  async post(context: ResponseContext) {
    if (context.response.status === 503) {
      try {
        const cloned = context.response.clone();
        const body = await cloned.json();
        if (body?.code === 'system_under_maintenance') {
          systemUnderMaintenance$.next(true);
        }
      } catch {
        // ignore json parse errors
      }
    }
  }
}
